import { render } from "./LayoutHeader.vue?vue&type=template&id=0163d697&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"

import "./LayoutHeader.vue?vue&type=style&index=0&id=0163d697&scoped=true&lang=css"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0163d697"]])

export default __exports__